module.exports = __webpack_public_path__ + "static/media/savvy-awesome-ipfs.ac13067f.svg";